export const adaptUser = (user) => {
    return {
        idUsuario: user?.idUsuario,
        usuario: user?.usuario,
        apellido: user?.apellido,
        email: user?.email,
        nombre: user?.nombre,
        activo: user?.activo,
        idUsuarioAuth: user?.idUsuarioAuth,
    }
}

export const adaptUserArray = (
    users
) => {
    return structuredClone(users?.allUsuarios?.items)
        ?.map(program => adaptUser(program));
}